export const initFaqScroll = () => {
  const company = document.querySelector(
    '.et_section_specialty .et_pb_row .company-link',
  );
  const investments = document.querySelector(
    '.et_section_specialty .et_pb_row .investments-link',
  );
  const markets = document.querySelector(
    '.et_section_specialty .et_pb_row .markets-link',
  );
  const whatToKnow = document.querySelector(
    '.et_section_specialty .et_pb_row .what-to-know-link',
  );

  if (!company || !investments || !markets || !whatToKnow) {
    return;
  }

  if (window.matchMedia('(min-width: 981px)').matches) {
    window.addEventListener('scroll', () => {
      const scroll = window.scrollY;

      if (scroll > 2100) {
        whatToKnow.classList.add('faq-active');
        markets.classList.remove('faq-active');
        company.classList.remove('faq-active');
        investments.classList.remove('faq-active');
      } else if (scroll > 1650) {
        markets.classList.add('faq-active');
        company.classList.remove('faq-active');
        investments.classList.remove('faq-active');
        whatToKnow.classList.remove('faq-active');
      } else if (scroll > 1200) {
        investments.classList.add('faq-active');
        company.classList.remove('faq-active');
        markets.classList.remove('faq-active');
        whatToKnow.classList.remove('faq-active');
      } else if (scroll > 800) {
        company.classList.add('faq-active');
        investments.classList.remove('faq-active');
        markets.classList.remove('faq-active');
        whatToKnow.classList.remove('faq-active');
      }
    });
  }
};
